import HttpService from "./htttp.service";

class TransactionsService {
  // TransactionsEndpoint = process.env.API_URL;

  getTransactions = async () => {
    const getTransactions = "dash/transactions";
    return await HttpService.get(getTransactions);
  };

  getTransactionsStats = async () => {
    const getTransactionsStats = "dash/transactions/stats";
    return await HttpService.get(getTransactionsStats);
  };

  getIncompleteTransactions = async () => {
    const getIncompleteTransactions = "dash/transactions/incomplete";
    return await HttpService.get(getIncompleteTransactions);
  };

  getSingleTransaction = async (id) => {
    const getSingleTransaction = `dash/transactions/${id}`;
    return await HttpService.get(getSingleTransaction);
  };

  createNewTransaction = async (transaction) => {
    const createNewTransaction = "dash/transactions/new";
    return await HttpService.post(createNewTransaction, transaction);
  };

  mpesaStkNewTransaction = async (transaction) => {
    const mpesaStkNewTransaction = "dash/transactions/stkpay";
    return await HttpService.post(mpesaStkNewTransaction, transaction);
  };

  editTransaction = async (id, transaction) => {
    const editTransaction = `dash/transactions/${id}`;
    return await HttpService.put(editTransaction, transaction);
  };
}

export default new TransactionsService();
